import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {

  constructor() { }

  calendar:any[];
  ngOnInit(): void {
    this.calendar=[
      {
        id:"1",
        From:"March 17",
        To:"March 20",
        Occasion:"Holi Holidays"
      },
      {
        id:"2",
        From:"Jan 1st",
        To:"Jan 1st",
        Occasion:"New Year"
      },

    ]
  }

}
